module.exports = __webpack_public_path__ + "assets/img/202110-1W.1d1e0c22.png";